export default "__VITE_ASSET__B_264dDk__"